import React, { ReactNode, useContext, useEffect, useState } from 'react';
import {
  Loader,
  ListHeader,
  ListItems,
  AppContext,
  useSuperListHook,
  ALL_TABLES
} from '@nile/components';

interface ListViewProps {
  components: {
    Card: ReactNode[];
    AdvancedFilter: ReactNode[];
  };
  tableName?: string;
  activeView: string;
}

const ListView = ({
  itemsLoading = true,
  isRefetching = true,
  context,
  allItems,
  module = 'ticket',
  tableName = ALL_TABLES.tickets,
  activeView,
  selectedRecords = [],
  classicViewHook,
  ...props
}): React.ReactElement => {
  const [selectAll, setSelectAll] = useState(false);
  const appContext = useContext(AppContext) as any;
  const darkTheme = appContext?.darkTheme;

  const toggleSelectAll = (booleanVal) => {
    if (booleanVal) {
      if (module === 'ticket') {
        classicViewHook?.updateRecords(allItems);
      } else if (module === 'patch') {
        context?.setRecords?.(allItems);
      } else {
        const selectionData = {
          allSelected: false,
          selectedRecords: allItems,
          unSelectedRecords: null,
          totalRecords: allItems.length,
          filterCondition: context?.filterCondition || null
        };
        context?.setRecords?.(selectionData);
        classicViewHook?.updateRecords(allItems);
      }
    } else {
      context?.setRecords([]);
      classicViewHook?.updateRecords([]);
    }
    setSelectAll(booleanVal);
  };

  const onItemUnselected = () => {
    setSelectAll(false);
  };

  return (
    <div className={`classicView_Sidebar fhp ${darkTheme && ' dark'}`}>
      <ListHeader
        selectAll={selectAll}
        toggleSelectAll={toggleSelectAll}
        module={module}
        activeView={activeView}
        {...props}
      />
      {itemsLoading || isRefetching ? (
        <Loader />
      ) : (
        <ListItems
          selectAll={selectAll}
          setSelectAll={setSelectAll}
          onItemUnselected={onItemUnselected}
          context={context}
          allItems={allItems}
          module={module}
          tableName={tableName}
          activeView={activeView}
          selectedRecords={selectedRecords}
          classicViewHook={classicViewHook}
          {...props}
        />
      )}
    </div>
  );
};

ListView.defaultProps = {
  components: {
    Card: (props) => {
      const { item } = props;
      return <div>{item.label || 'card no data'}</div>;
    },
    Pagination: () => {
      return <div>Pagination</div>;
    },
    AdvancedFilterComponent: () => {
      return <div> Filter</div>;
    }
  }
};
export default ListView;
